import { API_GET_CONFIG_START, API_GET_CONFIG_SUCCESS, API_GET_CONFIG_FAILURE } from '../types/config'

export const apiGetConfigStart = () => ({ type: API_GET_CONFIG_START })
export const apiGetConfigSuccess = config => ({ type: API_GET_CONFIG_SUCCESS, config })
export const apiGetConfigFailure = error => ({ type: API_GET_CONFIG_FAILURE, error })
